export const householdSize = {
  ME: 1,
  ME_PLUS_ONE: 2,
  ME_PLUS_MORE: 3,
} as const;

export type HouseholdSize = (typeof householdSize)[keyof typeof householdSize];
